import { Injectable } from '@angular/core';
import { FileManagerModel } from '../models/file-manager.model';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Global } from 'app/@core/lib/global';

@Injectable()
export class FileManagerService {

    constructor(
        private global: Global,
        private fileManagerModel: FileManagerModel,
        private http: HttpClient
    ) {

    }

    public uploadToCloudinary(data) {
        let client_id = this.global.loggedUser().client_id;
        let url = 'https://api.tecnologiaasap.com.br/api/cloudinary/upload/auth?client_id=' + client_id;
        let token = sessionStorage.getItem('token') || localStorage.getItem('token') || '';
        if (token && !token.startsWith('Bearer ')) {
            token = 'Bearer ' + token;
        }
        let headers = new HttpHeaders();
        if (token) {
            headers = headers.set('Authorization', token);
        }
        return this.http.post(url, data, { headers: headers, reportProgress: true, observe: 'events' });
    }

    public uploadFile(data: any): Observable<any> {
        return this.fileManagerModel.uploadFile(this.serialize(data));
    }

    public removeFile(id: number): Observable<any> {
        if (id) {
            return this.fileManagerModel.deleteFile(id);
        } else {
            return null;
        }
    }

    public findFileCollection(): Observable<any> {
        return this.fileManagerModel.getAll();
    }

    public serialize(data: any): FileManagerModel {
        const fileManager = new FileManagerModel(this.http);
        fileManager.name = data.name;
        fileManager.file = data;
        fileManager.description = data.type;
        return fileManager;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/file-manager/services/file-manager.service.ts